import ServerListener from 'www/modules/ServerListener'
import { AppointmentModules } from 'www/modules/appointment-modules'

import {
  getQueryParam,
  deleteQueryParam,
  getObjectQueryParams,
  transformObjectToClean,
  dispatchCustomEventGlobally,
  getBooleanFromString,
} from 'www/utils'
import scrollLock from 'src/utils/scrollLock'

import {
  createFreeClubCard,
  createPaidClubCard,
  getUserClubCardData,
} from 'www/vue_components/common/Club/components/core/ClubCardGetting/api'

import {
  eventsData,
  getStyleData,
  getClubData,
  getRedirectData,
  getPaymentMadeData,
  getErrorDataForStaff,
  getErrorDataForCancelPayment,
  getErrorData,
} from 'www/vue_components/common/Club/components/core/ClubCardGetting/interfaces'

import ManageYandexGoals from 'www/vue_components/common/mixins/ManageYandexGoals'

import { steps, PAYMENT_STATUSES, ALFA_BANK_PAYMENT_HOST_NAME } from 'www/vue_components/common/Club/components/core/ClubCardGetting/constants'

const appointmentMethods = new AppointmentModules()

export default {
  mixins: [
    ManageYandexGoals,
  ],
  data: vm => ({
    steps,
    state: {
      step: 0,
      isEnabledWidget: false,
    },
    events: eventsData,
    clubData: window.USER.club || getClubData(),
    userPhone: '',
    styleData: getStyleData(),
    errorData: getErrorData(),
    redirectData: getRedirectData(),
    paymentMadeData: getPaymentMadeData(),
    userIsAuthenticated: !window.USER.isAnonymous,
    instanceServerListener: null,
    errorButtonActions: {
      close: () => vm.closeWidget(),
      retry: () => vm.setStep('emailEnter'),
      reload: () => window.location.reload(),
    },
  }),
  created() {
    const { cardGettingOpen, detailInfoBannerClick } = this.events.club

    window.addEventListener(cardGettingOpen, this.handleOpenWidget)
    window.addEventListener(detailInfoBannerClick, this.handleOpenWidget)
  },
  mounted() {
    this.handleOpenWidgetAfterRedirect()
  },
  computed: {
    showConfettiImage() {
      return (this.state.step === this.steps.paymentMade) && this.paymentMadeData.isShowConfetti
    },
  },
  methods: {
    openWidget() {
      this.state.isEnabledWidget = true

      scrollLock.disableScroll()
    },
    closeWidget() {
      this.state.isEnabledWidget = false

      scrollLock.enableScroll()

      this.handleQueryParams()
    },
    removeSkeleton() {
      /**
       * Т.к. удаляемый по таймауту класс перебивает стили анимации для бесшовного
       * перехода skeleton'а к настоящему компоненту, то класс, соответственно,
       * нельзя удалять до завершения анимации, которая длится 300 ms
       */
      setTimeout(() => {
        document.body.classList.remove('club-card-getting-skeleton')
      }, 300)
    },
    handleOpenWidget({ detail } = {}) {
      if (!detail) {
        return
      }

      if (window.USER.isStaff || window.USER.isDoctor || window.USER.isLpu) {
        this.showErrorForStaff()
        this.openWidget()
        return
      }

      this.redirectData = detail

      this.setUserClubState()
      this.openWidget()
    },
    handleEventConfirmed(userPhone) {
      this.userPhone = userPhone
      this.userIsAuthenticated = true

      this.setStep('preloaderText')
      this.requestToUserClubCardData()
    },
    handleEventRedirectOrCancel() {
      if (this.redirectData.isRedirectViaBanner) {
        this.closeWidget()
        return
      }

      this.redirectToNewAppointment()
    },
    async handleCardGettingSubmit() {
      if (this.clubData.email) {
        this.setStep('preloaderOnly')
        this.handleEventEmailSent(this.clubData.email)

        return
      }

      if (this.clubData.cardNextPrice) {
        this.setStep('emailEnter')
        return
      }

      try {
        const {
          mt_link: cardMtLink,
          dt_end: cardDateEnd,
        } = await createFreeClubCard()

        this.updateUserClubCardData({
          isInClub: true,
          cardMtLink,
          cardDateEnd,
        })

        this.paymentMadeData.isRedirectViaBanner = this.redirectData.isRedirectViaBanner
        this.paymentMadeData.isShowConfetti = true

        this.setStep('paymentMade')
      } catch (e) {
        this.handleError(e)
      }
    },
    handleEventEmailSent(email) {
      this.redirectToPayment(email)
    },
    setStep(key) {
      this.state.step = this.steps[key]
    },
    redirectToNewAppointment() {
      appointmentMethods.redirectToNewAppointmentClinic(this.redirectData.appointmentData)
    },
    setUserClubState() {
      if (!this.userIsAuthenticated) {
        this.setStep('confirmation')

        return
      }

      if (this.clubData.isInClub) {
        this.paymentMadeData.isRedirectViaBanner = this.redirectData.isRedirectViaBanner

        this.setStep('paymentMade')

        return
      }

      this.setStep('clubEnter')
    },
    async redirectToPayment(email) {
      try {
        this.setStep('preloaderOnly')

        const response = await createPaidClubCard({
          email,
          returnUrl: this.createReturnUrl(),
        })

        const { provider_payment_data: paymentData } = response.payment_credentials

        if (paymentData.url) {
          window.location.assign(paymentData.url)

          return
        }

        this.showDefaultError()
      } catch (e) {
        this.handleError(e)
      }
    },
    async requestToUserClubCardData() {
      try {
        const userClubData = await getUserClubCardData()

        this.updateUserClubCardData(userClubData)
        this.setUserClubState()
      } catch (e) {
        this.handleError(e)
      }
    },
    updateUserClubCardData(newUserData) {
      this.clubData = {
        ...this.clubData,
        ...newUserData,
      }

      dispatchCustomEventGlobally('club-service-discount:updated-user-data', {
        userClubData: this.clubData,
      })
    },
    handleOpenWidgetAfterRedirect() {
      this.removeSkeleton()

      const requestIdQuery = getQueryParam('card_request_id')
      const requestId = parseInt(requestIdQuery, 10)
      const isValidRequestId = !Number.isNaN(requestId)
      const isRedirectFromAlfaBank = document.referrer.includes(ALFA_BANK_PAYMENT_HOST_NAME)

      if (isRedirectFromAlfaBank && isValidRequestId) {
        this.setStep('preloaderOnly')
        this.openWidget()

        this.instanceServerListener = new ServerListener({
          socketData: {
            url: `wss://${window.location.host}/ws/club_card_request?subscribe-user`,
            receiveCallback: this.handlePaymentStatus,
            errorCallback: this.handleError,
          },
          requestData: {
            timeout: 5000,
            url: `/ajax/club/card/request/${requestId}/status/`,
            successCallback: this.handlePaymentStatus,
            errorCallback: this.handleError,
          },
        })
      }
    },
    handlePaymentStatus({ data } = {}) {
      const { status } = data

      // TODO: удалить статус expired после того как его уберут на бэкенде
      if (status === PAYMENT_STATUSES.inProcess || status === PAYMENT_STATUSES.expired) {
        return
      }

      this.instanceServerListener.disconnect()

      const {
        dt_end: cardDateEnd,
        dt_start: cardDateStart,
        mt_link: cardMtLink,
      } = data

      this.updateUserClubCardData({
        cardDateEnd,
        cardDateStart,
        cardMtLink,
      })

      if (status === PAYMENT_STATUSES.paid) {
        this.handleQueryParams()
        this.updateUserClubCardData({ isInClub: true })

        this.paymentMadeData.isRedirectViaBanner = this.redirectData.isRedirectViaBanner
        this.paymentMadeData.isShowConfetti = true

        this.setStep('paymentMade')

        return
      }

      if (status === PAYMENT_STATUSES.canceled || status === PAYMENT_STATUSES.paymentFailed) {
        this.handleQueryParams()
        this.showErrorForCancelPayment()

        return
      }

      this.showDefaultError()
    },
    createReturnUrl() {
      const cleanAppointmentData = transformObjectToClean(this.redirectData.appointmentData, true)

      /* Очищаем слот для того, чтобы пользователь повторно выбрал время приёма. Это позволит избежать
            проблем когда слот может занять кто-нибудь другой, в момент оплаты клубной карты */
      delete cleanAppointmentData.slot

      const customCurrentUrl = new URL(window.location.href)
      const queryString = new URLSearchParams({
        ...cleanAppointmentData,
        isRedirectViaBanner: this.redirectData.isRedirectViaBanner,
      }).toString()

      if (customCurrentUrl.search) {
        customCurrentUrl.search += `&${queryString}`
      }

      customCurrentUrl.search = customCurrentUrl.search ? `${customCurrentUrl.search}&${queryString}` : `?${queryString}`

      return customCurrentUrl.href
    },
    handleQueryParams() {
      const queryParamsObject = getObjectQueryParams()
      const queryParamsObjectKeys = Object.keys(queryParamsObject)

      if (!queryParamsObjectKeys.length) {
        return
      }

      // Находим все свойства appointmentData которые находятся в query-параметрах и обновляем их
      queryParamsObjectKeys.forEach(key => {
        if (this.redirectData.appointmentData.hasOwnProperty(key)) {
          this.redirectData.appointmentData[key] = queryParamsObject[key]

          deleteQueryParam(key)
        }
      })

      if (queryParamsObject.isRedirectViaBanner) {
        this.redirectData.isRedirectViaBanner = getBooleanFromString(queryParamsObject.isRedirectViaBanner)
      }

      deleteQueryParam('isRedirectViaBanner')
      deleteQueryParam('card_request_id')
      deleteQueryParam('orderId')
      deleteQueryParam('lang')
    },
    handleError({ data, status } = {}) {
      if (status === 403) {
        // - Учетные данные не были предоставлены
        // - CSRF Failed: CSRF token missing or incorrect

        this.showDefaultError()

        return
      }

      // eslint-disable-next-line camelcase
      if (data?.button_state) {
        this.errorData = {
          title: data.title,
          message: data.message,
          buttonState: data.button_state,
        }

        this.setStep('error')

        return
      }

      this.showDefaultError()
    },
    handleActionInError(actionName) {
      const fn = this.errorButtonActions[actionName]

      if (typeof fn === 'function') {
        fn()

        return
      }

      this.showDefaultError()
    },
    showDefaultError() {
      this.errorData = getErrorData()
      this.setStep('error')
    },
    showErrorForStaff() {
      this.errorData = getErrorDataForStaff()
      this.setStep('error')
    },
    showErrorForCancelPayment() {
      this.errorData = getErrorDataForCancelPayment()
      this.setStep('error')
    },
  },
}
